module.exports = __webpack_public_path__ + "img/22b)(Hotel Fürstenhof)Montage gesamten öffentlichen Bereich.jpg";